import { render, staticRenderFns } from "./Kinesitherapy.vue?vue&type=template&id=168eb6c6&scoped=true"
import script from "./Kinesitherapy.vue?vue&type=script&lang=js"
export * from "./Kinesitherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168eb6c6",
  null
  
)

export default component.exports